/* gx-write-review.js — "Write a review" handoff to Loox's own submission form, with the
 * product picker. Loaded by every PDP reviews band via snippets/gx-write-review-list.liquid.
 *
 * Companion to the inline script in sections/reviews.liquid (the store-level reviews page,
 * which shipped first and is self-contained). This asset gives PDPs the SAME experience:
 * per Doug 2026-08-17, the button asks which product is being reviewed even on a product
 * page, "just in case they hit the wrong page." A trigger can still carry an explicit
 * data-gx-write-review="<id>" to skip the picker; the coral band buttons deliberately
 * leave it empty so the picker always asks.
 *
 * WHY OUR OWN BUTTON: Loox's widget button is grey, top-right, inside Loox's IFRAME — theme
 * CSS cannot recolor it (cross-origin). Doug 2026-08-17: match the reviews page's coral
 * button. Loox's grey button keeps working; ours is simply the visible one.
 *
 * The picker's ids are CANONICAL products (emitted by the snippet from canonical handles),
 * so reviews land in the same pools the PDPs display. "Combo" posts to Gut X's pool by
 * default and is reassigned internally in the Loox admin during review. Verified mechanism
 * (2026-08-17, live): LOOX.showReviewForm(id) injects
 * loox.io/widget/<clientId>/ugc/review-form?productId=<id>; looxWrite is the postMessage
 * fallback; the hosted URL renders standalone as the last resort.
 */
(function () {
  'use strict';

  var LOOX_CLIENT_ID = 'NJZoL50zcd';
  var HOSTED_FORM = 'https://loox.io/widget/' + LOOX_CLIENT_ID + '/ugc/review-form?productId=';

  /* Loox's app embed is deferred; poll briefly instead of dropping a fast click.
     40 x 150ms = 6s, then the hosted form takes over. */
  function openLoox(productId, attempt) {
    if (!productId) return false;
    attempt = attempt || 0;

    if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') {
      window.LOOX.showReviewForm(String(productId));
      return true;
    }
    if (typeof window.looxWrite === 'function') {
      window.looxWrite(String(productId));
      return true;
    }
    if (attempt < 40) {
      setTimeout(function () { openLoox(productId, attempt + 1); }, 150);
      return true;
    }
    window.location.href = HOSTED_FORM + encodeURIComponent(productId);
    return true;
  }

  /* ---------- product picker ---------- */

  function products() {
    var el = document.getElementById('gx-write-review-products');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function closePicker() {
    var open = document.querySelector('.gx-wr-overlay');
    if (open) open.remove();
    document.documentElement.style.overflow = '';
  }

  function openPicker(list) {
    closePicker();

    var overlay = document.createElement('div');
    overlay.className = 'gx-wr-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Which product are you reviewing?');

    var card = document.createElement('div');
    card.className = 'gx-wr-card';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'gx-wr-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';

    var eyebrow = document.createElement('div');
    eyebrow.className = 'gx-wr-eyebrow';
    eyebrow.textContent = 'Write a review';

    var title = document.createElement('h2');
    title.className = 'gx-wr-title';
    title.textContent = 'Which product are you reviewing?';

    var note = document.createElement('p');
    note.className = 'gx-wr-note';
    note.textContent = 'Pick the one you fed. Your review is posted against that product and stays tied to your order.';

    var choices = document.createElement('div');
    choices.className = 'gx-wr-choices';

    list.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gx-wr-choice';
      b.textContent = p.title;
      b.addEventListener('click', function () {
        closePicker();
        openLoox(p.id);
      });
      choices.appendChild(b);
    });

    card.appendChild(close);
    card.appendChild(eyebrow);
    card.appendChild(title);
    card.appendChild(note);
    card.appendChild(choices);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    /* Lock the page behind the dialog; mobile Safari scrolls the body under a fixed overlay
       otherwise. */
    document.documentElement.style.overflow = 'hidden';

    close.addEventListener('click', closePicker);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePicker(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closePicker(); document.removeEventListener('keydown', esc); }
    });

    var first = choices.querySelector('.gx-wr-choice');
    if (first) first.focus();
  }

  /* ---------- click handling ---------- */

  /* Guarded against double-binding if several sections load this asset. */
  if (window.__gxWriteReviewBound) return;
  window.__gxWriteReviewBound = true;

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-gx-write-review]');
    if (!trigger) return;

    e.preventDefault();

    /* Explicit product id on the trigger skips the picker. The coral band buttons leave it
       empty ON PURPOSE (Doug 2026-08-17): always ask, even on a product page, in case the
       customer is on the wrong one. */
    var pid = trigger.getAttribute('data-gx-write-review') || '';
    if (pid) { openLoox(pid); return; }

    var list = products();
    if (list.length === 1) { openLoox(list[0].id); return; }
    if (list.length) { openPicker(list); return; }

    /* No list rendered: the store-level reviews page carries its own. */
    window.location.href = '/pages/reviews';
  });
})();
